import type { AxiosResponse } from 'axios';

import { API } from '@/api';
import { axiosInstance } from '@/utils/fetcher';
import type { LossAndDamageClaimItem } from '@/views/screens/Claims/types';

export const PAGE_SIZE_DEFAULT = 10;

export interface GetClaimItemsRequestParams {
  claimKey: number;
  pageIndex: number;
  pageSize?: number;
  sortColumn?: string;
  sortDirection?: 'ASC' | 'DESC';
}

export interface ClaimItemsResponse {
  data: LossAndDamageClaimItem[];
  nextPage?: number;
  totalRows: number;
  totalProductClaimAmount: number;
}

export const getClaimItemsAPI = (params: GetClaimItemsRequestParams) => {
  return axiosInstance.request({
    method: 'get',
    params: {
      claimKey: params.claimKey,
      pageIndex: params.pageIndex,
      pageSize: params.pageSize || PAGE_SIZE_DEFAULT,
      sortColumn: params.sortColumn || 'itemSeq',
      sortDirection: params.sortDirection || 'DESC',
    },
    url: `${API.LOSS_AND_DAMAGE}/GetClaimItem`,
  });
};

export const fetchClaimItems = async (params: GetClaimItemsRequestParams): Promise<ClaimItemsResponse> => {
  const response: AxiosResponse<ClaimItemsResponse> = await getClaimItemsAPI(params);
  const data = response.data;
  const pageSize = Number(params.pageSize || PAGE_SIZE_DEFAULT);
  const totalPages = Math.ceil(Number(data.totalRows ?? 0) / pageSize);
  const hasMore = Number(params.pageIndex) < totalPages;

  return {
    ...data,
    nextPage: hasMore ? Number(params.pageIndex) + 1 : undefined,
  };
};
